import * as validators from '../../util/validators';

const AuPhoneWrapper = (render, intl) => {
  const requiredMessage = intl.formatMessage({ id: 'ContactDetailsForm.requiredMessage' });
  const validAuPhoneNoMess = {
    tooShort: intl.formatMessage({ id: 'ContactDetailsForm.tooShort' }),
    tooLong: intl.formatMessage({ id: 'ContactDetailsForm.tooLong' }),
  };
  const errors = {
    1: intl.formatMessage({ id: 'ContactDetailsForm.invalidCountryCode' }),
    2: intl.formatMessage({ id: 'ContactDetailsForm.tooShort' }),
    3: intl.formatMessage({ id: 'ContactDetailsForm.tooLong' }),
  };

  return render(
    validators.composeValidators(
      validators.required(requiredMessage),
      validators.validateAustraliaPhoneNumber(validAuPhoneNoMess),
      validators.validatePhoneNumber(errors)
    )
  );
};

export default AuPhoneWrapper;
